import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { TrendingUp, Droplets, Users, Award } from 'lucide-react';
import PublicNav from '../components/PublicNav';
import Footer from '../components/Footer';

const PLANT_TANKS = '/images/franchise.png';

export default function Franchise() {
  return (
    <div className="min-h-screen bg-white">
      <PublicNav activeItem="Franchise" />

      <section className="py-24 bg-slate-50" data-testid="franchise-page">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-center mb-16"
          >
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-brand-accent mb-4">FRANCHISE OPPORTUNITIES</p>
            <h1 className="text-5xl sm:text-6xl tracking-tighter font-light text-brand-primary font-outfit mb-6">Join Our Growing Network</h1>
            <p className="text-lg text-slate-600 max-w-3xl mx-auto">Partner with ZAN Aqua and be part of Pakistan's leading water purification franchise network</p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center mb-16">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <img src={PLANT_TANKS} alt="Franchise" className="w-full" />
            </motion.div>
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-3xl font-medium text-brand-primary font-outfit mb-6">Why Choose ZAN Aqua Franchise?</h2>
              <p className="text-base leading-relaxed text-slate-600 mb-6">
                With a proven business model and comprehensive support, our franchise program offers a lucrative opportunity in the ever-growing water purification industry.
              </p>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <TrendingUp className="h-6 w-6 text-brand-accent mr-3 mt-0.5 flex-shrink-0" />
                  <div>
                    <h4 className="font-medium text-brand-primary">High ROI Potential</h4>
                    <p className="text-sm text-slate-600">Proven business model with attractive profit margins</p>
                  </div>
                </li>
                <li className="flex items-start">
                  <Award className="h-6 w-6 text-brand-accent mr-3 mt-0.5 flex-shrink-0" />
                  <div>
                    <h4 className="font-medium text-brand-primary">Brand Recognition</h4>
                    <p className="text-sm text-slate-600">Leverage our established brand and customer trust</p>
                  </div>
                </li>
                <li className="flex items-start">
                  <Users className="h-6 w-6 text-brand-accent mr-3 mt-0.5 flex-shrink-0" />
                  <div>
                    <h4 className="font-medium text-brand-primary">Complete Support</h4>
                    <p className="text-sm text-slate-600">Training, marketing, and operational assistance</p>
                  </div>
                </li>
                <li className="flex items-start">
                  <Droplets className="h-6 w-6 text-brand-accent mr-3 mt-0.5 flex-shrink-0" />
                  <div>
                    <h4 className="font-medium text-brand-primary">Quality Equipment</h4>
                    <p className="text-sm text-slate-600">State-of-the-art RO plants and equipment</p>
                  </div>
                </li>
              </ul>
            </motion.div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="bg-white p-8 border border-slate-200 text-center"
            >
              <h3 className="text-4xl font-bold text-brand-accent mb-2">Rs. 15-25L</h3>
              <p className="text-slate-600">Investment Range</p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="bg-white p-8 border border-slate-200 text-center"
            >
              <h3 className="text-4xl font-bold text-brand-accent mb-2">12-18</h3>
              <p className="text-slate-600">Months Payback</p>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="bg-white p-8 border border-slate-200 text-center"
            >
              <h3 className="text-4xl font-bold text-brand-accent mb-2">30-40%</h3>
              <p className="text-slate-600">Profit Margin</p>
            </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="bg-brand-primary text-white p-12 text-center"
          >
            <h2 className="text-3xl font-medium mb-4">Ready to Start Your Journey?</h2>
            <p className="text-slate-200 mb-8 max-w-2xl mx-auto">Contact us today to learn more about franchise opportunities and how to become a ZAN Aqua partner.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://wa.me/923017196699?text=Hi,%20I'm%20interested%20in%20ZAN%20Aqua%20franchise"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-brand-accent text-white hover:bg-brand-accent-hover px-8 py-3 shadow-sm transition-all duration-200"
                data-testid="franchise-whatsapp-button"
              >
                Contact via WhatsApp
              </a>
              <Link
                to="/contact"
                className="bg-white text-brand-primary hover:bg-slate-100 px-8 py-3 transition-all duration-200"
                data-testid="franchise-contact-button"
              >
                Get in Touch
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
      <Footer />
    </div>
  );
}